export var ETelemetryType;
(function (ETelemetryType) {
    ETelemetryType["COUNTER"] = "counter";
    ETelemetryType["TIMER"] = "timer";
})(ETelemetryType = ETelemetryType || (ETelemetryType = {}));
//# sourceMappingURL=types.js.map